var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Collapse, Flex } from '@robinpowered/ui-kit';
export var CollapsibleCard = function (_a) {
    var title = _a.title, children = _a.children, rightContent = _a.rightContent, _b = _a.defaultExpanded, defaultExpanded = _b === void 0 ? false : _b;
    return (_jsx(CardWrapper, { items: [
            {
                key: '1',
                label: title,
                children: children,
                extra: _jsx(Flex, { justify: "flex-end", children: rightContent }),
            },
        ], defaultActiveKey: defaultExpanded ? '1' : undefined }));
};
var CardWrapper = styled(Collapse)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-collapse-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center !important;\n  }\n"], ["\n  .ant-collapse-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center !important;\n  }\n"])));
var templateObject_1;
